"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorMediaWideIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 5h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m0 12h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2M4 9h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1"/></svg>`
}, props));
EditorMediaWideIcon.displayName = 'EditorMediaWideIcon';
var _default = exports.default = EditorMediaWideIcon;